import { motion } from 'framer-motion'
import DocsLayout from '../components/DocsLayout'
import SEO from '../components/SEO'
import {
  FaWindows,
  FaBook,
  FaHandPeace,
  FaTree,
  FaMagic,
  FaLightbulb,
  FaLeaf,
  FaHeart,
  FaRocket,
  FaLock,
  FaBolt,
  FaPalette,
  FaSearch,
  FaBullseye,
  FaMouse,
  FaSync,
  FaApple,
  FaCode,
  FaPython,
  FaMobileAlt,
  FaHome,
  FaDownload,
  FaTools,
  FaCompactDisc,
  FaKey,
  FaUsb,
  FaDesktop
} from 'react-icons/fa'

const downloadSites = {
  windows: [
    {
      name: "微软官网",
      description: "提供的Windows纯净版系统具有较高的运行流畅度和兼容性，同时注重系统的稳定性和安全性。",
      url: "https://www.microsoft.com/zh-cn/software-download/windows10ISO",
      icon: <FaWindows className="text-blue-600" />,
      features: ["官方渠道", "纯净系统", "安全可靠"]
    },
    {
      name: "MSDN系统库",
      description: "一个致力于提供原版Windows生态服务的平台，旨在为用户提供安全、可靠的系统下载和安装服务。",
      url: "https://www.xitongku.com/",
      icon: <FaBook className="text-indigo-500" />,
      features: ["原版系统", "多种版本", "下载稳定"]
    },
    {
      name: "HelloWindows",
      description: "一个提供多种Windows操作系统版本镜像下载的平台，包括最新的Windows 11以及早期版本。",
      url: "https://hellowindows.cn/",
      icon: <FaHandPeace className="text-green-500" />,
      features: ["最新版本", "历史版本", "下载速度快"]
    },
    {
      name: "山己几子木",
      description: "一个快速更新操作系统资源的网站，提供从Windows XP到最新的Windows 11的MSDN官方镜像。",
      url: "https://msdn.sjjzm.com/",
      icon: <FaTree className="text-green-600" />,
      features: ["多种下载方式", "BT下载", "磁力链接"]
    },
    {
      name: "极简系统",
      description: "一个提供纯净版Windows系统下载的平台，致力于为用户提供最安全、最稳定的系统体验。",
      url: "https://www.sysmini.com/",
      icon: <FaMagic className="text-purple-500" />,
      features: ["纯净系统", "无广告", "运行稳定"]
    },
    {
      name: "ITELLYOU",
      description: "一个提供原版软件使用指导的网站，致力于帮助用户更好地使用原版软件。",
      url: "https://next.itellyou.cn/",
      icon: <FaLightbulb className="text-yellow-500" />,
      features: ["使用指导", "原版软件", "技术支持"]
    },
    {
      name: "绿色系统",
      description: "提供纯净版系统、win10纯净版、win7纯净版、纯净版XP系统下载，让电脑运行飞快。",
      url: "https://lvsexitong.com/",
      icon: <FaLeaf className="text-green-400" />,
      features: ["纯净系统", "运行快速", "无广告"]
    },
    {
      name: "吻妻出品",
      description: "致力于分享最新最好用的Windows7纯净旗舰版系统下载。",
      url: "https://www.newxitong.com/",
      icon: <FaHeart className="text-red-400" />,
      features: ["Win7系统", "纯净版", "稳定可靠"]
    },
    {
      name: "WINOS",
      description: "一个提供前沿的精简系统下载的平台，提供的系统都是精简版的，不包含任何捆绑软件或广告。",
      url: "https://www.winos.me/",
      icon: <FaRocket className="text-orange-500" />,
      features: ["精简系统", "无捆绑", "运行流畅"]
    },
    {
      name: "imsdn",
      description: "一个提供MSDN原版系统和安装教程的个人网站。为广大的用户提供纯净、安全的原版系统。",
      url: "https://www.imsdn.cn/",
      icon: <FaLock className="text-blue-500" />,
      features: ["原版系统", "安装教程", "安全可靠"]
    },
    {
      name: "TWM000",
      description: "一个专注于系统精简的网站，提供各种版本的Windows系统精简版下载，以及相关的使用教程和技术支持。",
      url: "https://twm000.top/",
      icon: <FaBolt className="text-yellow-400" />,
      features: ["系统精简", "使用教程", "技术支持"]
    },
    {
      name: "不忘初心博客",
      description: "提供精简版和美化版Windows系统，满足了不同用户的需求。",
      url: "https://www.pc528.net/",
      icon: <FaPalette className="text-pink-500" />,
      features: ["精简系统", "美化系统", "个性化设置"]
    },
    {
      name: "MSDL",
      description: "一个提供可搜索的微软Windows系统下载列表的网站。",
      url: "https://massgrave.dev/msdl/",
      icon: <FaSearch className="text-gray-600" />,
      features: ["可搜索", "系统列表", "下载方便"]
    },
    {
      name: "Y OS工作室",
      description: "创建于2012年08月27日，一个Windows极简纯净系统镜像下载的网站。",
      url: "http://y-os.net/",
      icon: <FaBullseye className="text-red-500" />,
      features: ["极简系统", "纯净镜像", "历史悠久"]
    },
    {
      name: "OS.click",
      description: "一个免费的操作系统下载平台，提供各种流行操作系统的下载链接。",
      url: "https://os.click/en",
      icon: <FaMouse className="text-blue-400" />,
      features: ["多系统", "免费下载", "资源丰富"]
    },
    {
      name: "UUP Dump",
      description: "从 Windows Update 服务器中下载 UUP 文件并转换成最新的 Windows 镜像。",
      url: "https://uupdump.net/",
      icon: <FaSync className="text-green-500" />,
      features: ["最新版本", "自定义镜像", "组件可选"]
    }
  ],
  mac: [
    {
      name: "Apple macOS",
      description: "在兼容的 Mac 电脑上下载和安装最新或以前版本的 Mac 操作系统。",
      url: "https://support.apple.com/zh-cn/102662",
      icon: <FaApple className="text-gray-800" />,
      features: ["官方渠道", "最新版本", "安全可靠"]
    },
    {
      name: "Apple Developer",
      description: "提供了苹果开发者所需的各种工具和系统镜像下载，包括macOS系统的最新版本和beta版本。",
      url: "https://developer.apple.com/download/",
      icon: <FaCode className="text-gray-700" />,
      features: ["开发者资源", "Beta版本", "完整工具"]
    },
    {
      name: "gibMacOS",
      description: "一个 Python 脚本，可以从 Apple 服务器直接下载 macOS 组件，包括安装程序、恢复映像和更新。",
      url: "https://github.com/corpnewt/gibMacOS",
      icon: <FaPython className="text-blue-500" />,
      features: ["开源工具", "直接下载", "组件完整"]
    },
    {
      name: "sysin",
      description: "macOS 下载汇总，包括系统、应用和教程。",
      url: "https://sysin.org/blog/macOS/",
      icon: <FaMobileAlt className="text-green-500" />,
      features: ["资源汇总", "应用下载", "使用教程"]
    },
    {
      name: "苹果系统之家",
      description: "提供macOS苹果系统原版镜像永久免费下载。",
      url: "https://macoshome.com/",
      icon: <FaHome className="text-red-500" />,
      features: ["原版镜像", "免费下载", "资源丰富"]
    }
  ]
}

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
]

const Downloads = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="系统下载资源"
        description="提供Windows和Mac系统官方下载资源，包括原版系统、纯净版系统等，所有系统来源可靠，无捆绑无广告。"
        keywords="系统下载,Windows下载,Mac下载,纯净系统,原版系统,系统镜像"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center"
      >
        系统下载资源 <FaDownload className="inline text-primary ml-1" />
      </motion.h1>

      <div className="mb-12">
        <motion.h2 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-2xl font-bold text-gray-800 mb-6 flex items-center"
        >
          <FaWindows className="text-blue-600 mr-2 text-2xl" /> Windows 系统下载
        </motion.h2>
        
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {downloadSites.windows.map((site, index) => (
            <motion.div
              key={site.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="card"
            >
              <div className="flex items-center mb-4">
                <div className="text-2xl mr-3">{site.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800">{site.name}</h3>
              </div>
              <p className="text-gray-600 mb-4">{site.description}</p>
              <div className="mb-4">
                <h4 className="font-medium text-gray-700 mb-2">特点：</h4>
                <ul className="list-disc list-inside text-sm text-gray-600">
                  {site.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
              <a
                href={site.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
              >
                访问网站
              </a>
            </motion.div>
          ))}
        </div>
      </div>

      <div>
        <motion.h2 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-2xl font-bold text-gray-800 mb-6 flex items-center"
        >
          <FaApple className="text-gray-800 mr-2 text-2xl" /> macOS 系统下载
        </motion.h2>
        
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {downloadSites.mac.map((site, index) => (
            <motion.div
              key={site.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="card"
            >
              <div className="flex items-center mb-4">
                <div className="text-2xl mr-3">{site.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800">{site.name}</h3>
              </div>
              <p className="text-gray-600 mb-4">{site.description}</p>
              <div className="mb-4">
                <h4 className="font-medium text-gray-700 mb-2">特点：</h4>
                <ul className="list-disc list-inside text-sm text-gray-600">
                  {site.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
              <a
                href={site.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
              >
                访问网站
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </DocsLayout>
  )
}

export default Downloads 